import {
    IS_BAG,
    IS_EDITING,
    SET_MASTER_DO_MODIFIED,
    SET_DO_ITEMS,
    SET_DO_SUB_ITEMS,
    SET_DATA_FOR_GGC_TRANS,
    SET_DATA_FOR_GGC_TRANS_DO_ITEM,
    SHOW_DO_LIST
} from "../actions/types";

const initialState = {
   isBag: false,
   isEditing: false,
   showDoList: false
};

const SaleAtExternalReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case IS_BAG:
            return { ...state, isBag: payload };

        case IS_EDITING:
            return { ...state, isEditing: payload };

        case SHOW_DO_LIST:
            return { ...state, showDoList: payload };

        //case SET_MASTER_DO_MODIFIED:
        //    return { ...state, masterDoModified: payload }

        //case SET_DATA_FOR_GGC_TRANS:
        //    return { ...state, dataForGGCtrans: payload }

        //case SET_DATA_FOR_GGC_TRANS_DO_ITEM:
        //    return {...state, dataForGGCtransDoItem: payload}

        //case SET_DO_ITEMS:
        //    return { ...state, doItems: payload }

        //case SET_DO_SUB_ITEMS:
        //    return {...state, doSubItems: payload}

        default:
            return state;
    }
};

export default SaleAtExternalReducer;